import { useEffect } from 'react';
import { SECURITY } from './config';

// ============================================================
// Componente sin UI. Se monta una vez en App.tsx y aplica la capa
// de proteccion de contenido descrita en security/config.ts.
//
// REGLA DE ORO: ninguna proteccion puede romper una conversion.
// Por eso todo lo que sigue deja pasar los campos de formulario.
// ============================================================

const isEditable = (target: EventTarget | null): boolean => {
  const el = target as HTMLElement | null;
  if (!el || typeof el.tagName !== 'string') return false;
  const tag = el.tagName.toLowerCase();
  return tag === 'input' || tag === 'textarea' || el.isContentEditable === true;
};
export function Protection() {
  useEffect(() => {
    // --- Referrer policy: la URL completa (con utm_campaign, utm_content
    // y el subId) no viaja a sitios de terceros. Es inteligencia de
    // campana que no tienes por que regalar.
    if (SECURITY.strictReferrerPolicy) {
      let meta = document.head.querySelector('meta[name="referrer"]') as HTMLMetaElement | null;
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = 'referrer';
        document.head.appendChild(meta);
      }
      meta.content = 'strict-origin-when-cross-origin';
    }
    const onContextMenu = (e: MouseEvent) => {
      if (!SECURITY.blockContextMenu) return;
      // El usuario DEBE poder pegar su correo. Nunca bloquear aqui.
      if (isEditable(e.target)) return;
      e.preventDefault();
    };
    const onDragStart = (e: DragEvent) => {
      if (!SECURITY.blockImageDrag) return;
      const el = e.target as HTMLElement | null;
      if (el && el.tagName === 'IMG') e.preventDefault();
    };
    const onKeyDown = (e: KeyboardEvent) => {
      if (!SECURITY.blockDevtoolsShortcuts) return;
      if (isEditable(e.target)) return;
      const key = e.key.toLowerCase();
      const mod = e.ctrlKey || e.metaKey;
      if (e.key === 'F12') {
        e.preventDefault();
        return;
      }
      if (mod && e.shiftKey && (key === 'i' || key === 'j' || key === 'c')) {
        e.preventDefault();
        return;
      }
      // Ctrl+U (ver fuente) y Ctrl+S (guardar pagina).
      if (mod && (key === 'u' || key === 's')) {
        e.preventDefault();
      }
    };
    const onCopy = (e: ClipboardEvent) => {
      if (!SECURITY.copyAttribution) return;
      const selection = window.getSelection()?.toString() ?? '';
      if (selection.length < SECURITY.copyAttributionMinChars) return;
      e.preventDefault();
      const source = `\n\nFuente: Blinkblis — ${window.location.href}`;
      e.clipboardData?.setData('text/plain', selection + source);
    };
    document.addEventListener('contextmenu', onContextMenu);
    document.addEventListener('dragstart', onDragStart);
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('copy', onCopy);
    return () => {
      document.removeEventListener('contextmenu', onContextMenu);
      document.removeEventListener('dragstart', onDragStart);
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('copy', onCopy);
    };
  }, []);
  return null;
}